@if (showIcon) {
  <i
    class="icon-info1"
  aria-hidden="true"></i>
}
<span class="generic-table--no-results-title">
  {{ title }}
  @if (description) {
    <div
      class="generic-table--no-results-description"
    [innerHTML]="description"></div>
  }
</span>
